import { CardSection } from '@/_components/ui/card'
import { ReleaseHandoffButton } from '@/features/applications/_components/release-handoff-button'
import type { TExposedApplicationAggregateDTO } from '@doutorsim/shared/applications'

type ReleaseHandoffCardProps = {
  application: TExposedApplicationAggregateDTO
}

export const ReleaseHandoffCard = ({ application }: ReleaseHandoffCardProps) => {
  if (application.status !== 'pending-handoff') return null

  return (
    <CardSection className="flex-row items-center justify-between gap-6 py-5">
      <div className="flex flex-col gap-1">
        <span className="text-sm font-bold">Crédito aprovado - contato inicial pendente</span>
        <span className="text-sm text-brand-grayscale-7">
          Converse com o paciente sobre a proposta e libere o envio da mensagem de aprovação pelo
          WhatsApp.
        </span>
      </div>
      <ReleaseHandoffButton
        applicationId={application.id}
        companyId={application.companyId}
        facilityId={application.facilityId}
      />
    </CardSection>
  )
}
